import { MessageRecord } from "./locale";
import { some, none, Option } from "./option";

export type Base = string | number | string[] | MessageRecord;


export const tryNumber = (n: any) =>
  typeof n === "number" ? some(n) : (none as Option<number>);

export const tryString = (s: any) =>
  typeof s === "string" ? some(s) : (none as Option<string>);

export const isArray = (arr: any) =>
  Array.isArray(arr) ? some(arr) : (none as Option<string[]>);

export const isRecord = (record: any)=>
  record["fr"] && record["nl"] ? some(record): (none as Option<MessageRecord>)